import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { TokenRefreshToken } from './models';

@Injectable()
export abstract class RefreshTokenProvider {
  public abstract refreshToken(tokenInfo: TokenRefreshToken): Observable<string>;
}
